import { render, staticRenderFns } from "./thumbs.vue?vue&type=template&id=18cec4ec&scoped=true&lang=pug&"
import script from "./thumbs.vue?vue&type=script&lang=js&"
export * from "./thumbs.vue?vue&type=script&lang=js&"
import style0 from "./thumbs.vue?vue&type=style&index=0&id=18cec4ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cec4ec",
  null
  
)

export default component.exports